export const getSliced = (text, length) => {
  if (text && (text?.length > length)) {
    return text?.slice(0, length).concat('...');
  } else {
    return text || '';
  }
};
